import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  menuOpen = false;

  constructor(private router: Router, private authService: AuthService) {}

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }


  isControlRoute(): boolean {
    return (
      this.router.url.startsWith('/control') ||
      this.router.url.startsWith('/members') ||
      this.router.url.startsWith('/public-member') ||
      this.router.url.startsWith('/events') ||
      this.router.url.startsWith('/user-profile')
    );
  }

  goToUserProfile() {
    this.router.navigateByUrl('/user-profile');
  }

  goToControl() {
    this.router.navigateByUrl('/control');
  }

  goToMembers() {
    this.router.navigateByUrl('/members');
  }

  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}
